import axios from 'axios';
export const API_URL = "https://api.profitmaxprosuite.com";
export const AXIOS_API_INSTANCE = axios.create();
AXIOS_API_INSTANCE.defaults.baseURL = API_URL;
AXIOS_API_INSTANCE.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
export const BASE_AXIOS_API_INSTANCE = axios.create();
BASE_AXIOS_API_INSTANCE.defaults.baseURL = API_URL;
BASE_AXIOS_API_INSTANCE.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
export const lightColor = 'rgba(255, 255, 255, 0.7)';
export const CEDAR_TITANS_COLOR = '#04847e'
export const all_locations_object = { "id": "all", "name": "All Locations", "label": "All Locations" }
export const customer_user_object = { "id": "CUSTOMER", "name": "CUSTOMER" }
export var CLIENT_ID = 0
export const SET_CLIENT_ID = (new_id) => CLIENT_ID = new_id

export const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const LONG_DATE_FORMAT = 'ddd, D MMM YYYY h:mm A'
export const LONG_DAY_FORMAT = 'ddd, D MMM YYYY'
export const SHORT_DATE_FORMAT = 'ddd, D MMM h:mm A'
export const SHORTER_DATE_FORMAT = 'D MMM h:mm A'
export const STATE_ABBREVIATIONS = [
    // https://en.wikipedia.org/wiki/List_of_states_and_territories_of_the_United_States#States.
    "AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "IA",
    "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO",
    "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK",
    "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI",
    "WV", "WY",
    // https://en.wikipedia.org/wiki/List_of_states_and_territories_of_the_United_States#Federal_district.
    "DC",
]
export const CUSTOMER_INTEGRATION_ATTRIBUTES_FRIENDLY_NAMES = {
    "paladin_id": "Paladin ID"
}
export const LOCATION_INTEGRATIONS_FRIENDLY_NAMES = {
    "BLOCKCHYP": 'BlockChyp',
    "CARDPOINTE": 'CardPointe',
    "TWILIO": 'Twilio',
    "MAILGUN": 'Mailgun',
    "ZEBRA_PRINTER": 'Zebra Printer',
    "PALADIN": 'Paladin',
}
export const INVOICE_STATUS_FRIENDLY_NAMES = {
    "DEPOSIT": 'Deposit',
    "ON_HOLD": 'On Hold',
    "PAYMENT_PENDING": 'Payment Pending',
    "PAID": 'Paid'
}
export const PAYMENT_STATUS_COLOR_MAP = {
    "PROCESSING": 'orange',
    "PAID": 'green',
    "LINK-SENT": 'orange',
    "CANCELED": 'grey',
    "FAILED": 'error',
}

export const RENTAL_STATUS_FRIENDLY_NAMES = {
    'RESERVED': 'Reserved',
    'CHECKED_OUT': 'Out',
    'CHECKING_IN': 'Partial',
    'CHECKED_IN': 'Complete',
    'CANCELED': 'Canceled'
}

export const RENTAL_CONTRACT_COLOR_MAP = {
    "RESERVED": 'primary',
    "CHECKED_OUT": 'orange',
    "CHECKING_OUT": 'orange',
    "CHECKING_IN": 'orange',
    "CHECKED_IN": 'green',
    "CANCELED": 'grey'
}

export const SERVICE_ORDER_STATUS_TYPES = ['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE', 'INVOICED', 'COMPLETED', 'DECLINED']
export const get_service_order_color = (client_statuses, status) => {
    return client_statuses[status]?.custom_color ?? 'primary'
}
export const SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES = {
    'NOT_REQUESTED': 'No Approval Requested',
    'APPROVAL_REQUESTED': 'Approval Requested',
    'CUSTOMER_RESPONDED': 'Customer Responded',
    'APPROVED': 'Approved',
    'DECLINED': 'Declined'
}
export const SERVICE_ORDER_CUSTOMER_APPROVAL_COLOR_MAP = {
    'NOT_REQUESTED': 'lightOrange',
    'APPROVAL_REQUESTED': 'orange',
    'CUSTOMER_RESPONDED': 'green',
    'APPROVED': 'green',
    'DECLINED': 'grey'
}
export const SERVICE_ORDER_SERVICE_FRIENDLY_NAMES = {
    'PENDING': 'Pending',
    'IN_PROGRESS': 'In Progress',
    'COMPLETED': 'Completed',
    'DECLINED': 'Declined'
}
export const SERVICE_ORDER_SERVICE_COLOR_MAP = {
    "PENDING": 'primary',
    "IN_PROGRESS": 'orange',
    "COMPLETED": 'green',
    "DECLINED": 'grey'
}
export const get_service_order_part_color = (client_parts_statuses, status) => {
    return client_parts_statuses[status]?.custom_color ?? 'primary'
}
export const SERVICE_ORDER_PART_STATUS_TYPES = ['CREATED', 'ACQUIRING', 'READY', 'IN_PROGRESS', 'INSTALLED', 'DECLINED']
export const SERVICE_ORDER_PART_COLOR_MAP = {
    "AWAITING_PART": 'primary',
    "ON_ORDER": 'warning',
    "BACKORDERED": 'error',
    "READY": 'lightOrange',
    "IN_PROGRESS": 'orange',
    "INSTALLED": 'green',
    'DECLINED': 'grey',
}